(function(angular) {
    /**
     * @ngdoc object
     * @name KeyCodeController
     * @description Evaluates an expression when a specific key was pressed on the current $element.
     * The directive defaults to Enter key press, but can be configured by providing a different key code on the `code` attribute.
     * Eg. This directive might be used to open a modal when the user presses the Enter key on the modal trigger element
     * <button key-code="openModal($event)" code="13">Focus me and press Enter</button>
     */
    class KeyCodeController {
        static get $inject() {
            return ['$attrs', '$element', '$scope'];
        }

        constructor($attrs, $element, $scope) {
            this.$attrs = $attrs;
            this.$element = $element;
            this.$scope = $scope;
            this.evaluateKeyDownCallback = this.evaluateKeyDown.bind(this);

            /**
             * The keyboard event key code to listen to
             * @type {number}
             */
            this.code = this.ENTER_KEY_CODE;
        }

        get ENTER_KEY_CODE() {
            return 13;
        }

        $postLink() {
            this.$element.on('keydown', this.evaluateKeyDownCallback);

            if (this.$attrs.code) {
                this.code = this.$attrs.code;
            }
        }

        $onDestroy() {
            this.$element.off('keydown', this.evaluateKeyDownCallback);
        }

        /**
         * @ngdoc method
         * @name KeyCodeController#evaluateKeyDown
         * @description Callback on keyboard events on the current $element
         * @param {Event} $event The keyboard event
         */
        evaluateKeyDown($event) {
            const eventCode = $event.which || $event.keyCode;

            /* eslint eqeqeq:0 */
            if (eventCode == this.code || this.code == '*') {
                this.$scope.$apply(() => (this.$scope.$eval(this.$attrs.keyCode, {$event})));
            }
        }
    }

    angular.module('wtUi')
        .directive('keyCode', [function() {
            return {
                scope: false,
                bindToController: true,
                restrict: 'A',
                controller: KeyCodeController
            };
        }]);
})(window.angular, window._);
